import { Stack } from '@mui/system';
import { Dispatch, SetStateAction } from 'react';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import CompanyCertificationsEditModal from './components/CompanyCertificationsEditModal';
import { truncate } from '../../../../../../../../../utils/helpers';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyCertificationsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyCertifications = ({
  isEditModalOpen,
  setIsEditModalOpen,
}: CompanyCertificationsProps) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.certifications?.map((certification: string) => (
        <CustomChip
          tooltipTitle={certification}
          key={certification}
          label={
            certification && truncate(certification as string, CHIP_LABEL_TRUNCATE_VALUE as number)
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}
      {companyData && isEditModalOpen && (
        <CompanyCertificationsEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyCertifications;
